import {createI18n} from 'vue-i18n'
import {watch} from 'vue'
import {en} from "./en.ts";
import {ru} from "./ru.ts";

export const i18n = createI18n({
    legacy: false,
    locale: navigator.language,
    fallbackLocale: 'en',
    messages: {
        en: en,
        ru: ru
    }
})

const resolveHtmlLang = (lang: string) => lang.startsWith('ru') ? 'ru' : 'en'

document.documentElement.lang = resolveHtmlLang(i18n.global.locale.value)
watch(() => i18n.global.locale.value, (lang) => {
    document.documentElement.lang = resolveHtmlLang(lang)
})
